import { memo } from 'react';
import './SingleCard.css';

export default memo(function SingleCard({ card, handleChoice, flipped, disabled, level }) {
    const handleClick = () => {
        if (!disabled) {
            handleChoice(card);
        }
    };

    const cardBackSrc = `/img/${level}/${level}-cover.jpg`;

    return (
        <div className={`card ${card.matched ? 'matched' : ''}`} onClick={handleClick}>
            <div className={flipped ? 'flipped' : ''}>
                <img className="front" src={card.src} alt="card front" />
                <img className="back" src={cardBackSrc} alt="card back" />
            </div>
        </div>
    );
});
